import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { Container, Grid } from "@mui/material";
import image from "assets/images/ai.jpg";
import Icon from "@mui/material/Icon";

function AboutMe() {
  return (
    <MKBox component="section" py={{ xs: 6, md: 12 }}>
      <Container sx={{ maxWidth: "100% !important" }}>
        <Grid container item xs={10} sx={{ mx: "auto" }}>
          <MKBox variant="gradient" bgColor="info" borderRadius="lg" width="100%" py={6}>
            <Grid container>
              <Grid item xs={12} md={6} xl={4} sx={{ position: "relative", px: 6 }}>
                <MKBox
                  component="img"
                  src={image}
                  alt="image"
                  borderRadius="md"
                  maxWidth="300px"
                  width="100%"
                  position="relative"
                  mt={-12}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                xl={7}
                sx={{
                  position: "relative",
                  px: { xs: 6, md: 2 },
                  mt: { xs: 3, md: 0 },
                  my: { xs: 0, md: "auto" },
                  color: ({ palette: { white } }) => white.main,
                }}
              >
                <MKTypography
                  variant="body2"
                  color="white"
                  fontWeight="light"
                  mb={2}
                  sx={{ fontSize: "1.125rem" }}
                >
                  Dankzij kunstmatige intelligentie kunnen we kennis over honden nu ook online
                  aanbieden. In plaats van een heel boek te lezen, kun je gewoon je vraag stellen
                  aan Willy Woef en meteen het antwoord krijgen dat je zoekt. Je kunt doorvragen,
                  extra uitleg krijgen, of een ander onderwerp aansnijden, net als in een echt
                  gesprek.
                </MKTypography>
                <MKTypography
                  variant="body2"
                  color="white"
                  fontWeight="light"
                  mb={2}
                  sx={{ fontSize: "1.125rem" }}
                >
                  En als Willy Woef het antwoord op je vraag niet weet? Als je wil, dan stuurt hij
                  je vraag automatisch door. Je krijgt dan via de email een goed en duidelijk
                  antwoord toegezonden. Zo weet je zeker dat je altijd geholpen wordt.
                </MKTypography>
                <MKTypography
                  component="a"
                  href="/portaal"
                  variant="button"
                  color="light"
                  fontWeight="regular"
                  mt={5}
                  mx="auto"
                  sx={{
                    width: "max-content",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "& .material-icons-round": {
                      fontSize: "1.125rem",
                      transform: "translateX(3px)",
                      transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                    },

                    "&:hover .material-icons-round, &:focus .material-icons-round": {
                      transform: "translateX(6px)",
                    },
                  }}
                >
                  Probeer de chatbot gratis
                  <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                </MKTypography>
              </Grid>
              <Grid item xs={1} />
            </Grid>
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default AboutMe;
